var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-icon close-btn",attrs:{"data-cy":"close-btn"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('click')}}},[_c('fa-icon',{attrs:{"icon":"times"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }